import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AutoTraderApi } from 'api/AutoTraderAPI';
import MonthEndLosses from 'api/models/MonthEndLosses.model';
import { FULFILLED, IDLE, LOADING } from 'redux/constants';
import { AppStore } from 'redux/store';

const STORE_NAME = 'loss';

export interface LossState {
  losses: MonthEndLosses[];
  status: string;
}

const initialState: LossState = {
  losses: [],
  status: IDLE,
};

interface requestParams {
  marketParticipantId: string;
  startAt?: string;
  stopAt?: string;
}

export const fetchLosses = createAsyncThunk(
  `${STORE_NAME}/fetchLosses`,
  async (requestParams: requestParams) => {
    try {
      const { marketParticipantId, startAt, stopAt } = requestParams;
      const response = await AutoTraderApi.getLossReport(
        marketParticipantId,
        startAt?.replaceAll('+', '-'),
        stopAt?.replaceAll('+', '-')
      );
      if (response.error || response.length === 0) {
        return { ...initialState, status: FULFILLED };
      }
      return { losses: response, status: FULFILLED };
    } catch (error) {}
  }
);

export const lossesSlice = createSlice({
  name: STORE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLosses.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(fetchLosses.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      });
  },
});

export const selectLosses = (state: AppStore) => {
  return state.losses.losses as MonthEndLosses[];
};

export default lossesSlice.reducer;
